import { apiClient } from "./apiClient";
import { endpoints } from "./endpoints";
import type { ApiRecord } from "@/types/api";

/**
 * Backend v2.1 (Sprint 4.3) Analytics Read Model. `getAnalytics`/
 * `getPerformanceMetrics` are genuine, zero-fabricated-`equity_curve`
 * reads of whatever `AnalyticsPipeline` has already persisted as an
 * `AnalyticsSnapshot` for a `portfolio_id` - structured DTOs, not the
 * Sprint 3.1-era debug string. `generateSnapshot` wraps the one write
 * path (moved to `POST /analytics/generate` in Sprint 4.3) for
 * completeness - not invoked by any page.
 */
export const analyticsService = {
  async getAnalytics(portfolioId: string): Promise<ApiRecord> {
    const response = await apiClient.get<ApiRecord>(endpoints.analytics.root, {
      params: { portfolio_id: portfolioId },
    });
    return response.data;
  },
  async getPerformanceMetrics(portfolioId: string): Promise<ApiRecord> {
    const response = await apiClient.get<ApiRecord>(endpoints.analytics.performance, {
      params: { portfolio_id: portfolioId },
    });
    return response.data;
  },
  async generateSnapshot(params: AnalyticsSnapshotGenerationParams): Promise<ApiRecord> {
    const response = await apiClient.post<ApiRecord>(endpoints.analytics.generate, undefined, {
      params: {
        portfolio_id: params.portfolioId,
        equity_curve: params.equityCurve,
        elapsed_days: params.elapsedDays,
      },
    });
    return response.data;
  },
};

export interface AnalyticsSnapshotGenerationParams {
  portfolioId: string;
  equityCurve: number[];
  elapsedDays?: number;
}
